
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const DocCSV = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="DocCSV" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <g fill={colorArray[0]} className="color0" >
    <path d="M9 0H2v16h12V5zm0 1.4L12.6 5H9zM13 15H3V1h5v5h5z" />
    <path d="M6.373 9.179a3.015 3.015 0 00-.273 1.329 2.719 2.719 0 00.559 1.848 2.042 2.042 0 001.62.644 3.459 3.459 0 001.337-.25v-.865a3.851 3.851 0 01-1.237.256q-1.221 0-1.219-1.627A2.034 2.034 0 017.479 9.3a1.05 1.05 0 01.9-.437 1.64 1.64 0 01.542.095 5.459 5.459 0 01.549.226l.33-.843A3.276 3.276 0 008.379 8a2.35 2.35 0 00-1.213.3 2 2 0 00-.793.879z" />
  </g>
</svg>
    </HvIconBase>
)};

DocCSV.propTypes = HvIconBase.propTypes;

export default DocCSV;